import { schema } from "normalizr"

const discipleProfile = new schema.Entity("profiles")
const discipleSchema = new schema.Entity("disciples", {
  profile: discipleProfile,
})

export default discipleSchema
